import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { columns } from "./session-attendance-list-column-definition";
import commonStyles from "../../../style/common.module.css";
import { Dayjs } from "dayjs";
import { EDUCATION_SESSION_ATTENDANCE_DETAIL } from "../../../../infrastructure/route";
import { getCalendarSessions } from "../../service/session-attendance-service";
import { CalendarSessionOverview } from "../../model/calendar-session-overview";
import { BaseList } from "../../../../component/list/base-list";
import { getCohorts } from "../../service/cohort-service";
import { Cohort } from "../../model/cohort";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export default function SessionAttendanceList() {
    const [loading, setLoading] = useState(true);
    const [sessions, setSessions] = useState<CalendarSessionOverview[]>([]);
    const [cohorts, setCohorts] = useState<Cohort[]>([]);
    const [selectedCohortId, setSelectedCohortId] = useState<number | ''>('');
    const [from, setFrom] = useState<Dayjs | null>(null);
    const [to, setTo] = useState<Dayjs | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
        getCohorts().then(result => {
            const activeCohorts = (result ?? []).filter(c => c.active && c.googleCalendarId);
            setCohorts(activeCohorts);
            if (activeCohorts.length > 0 && selectedCohortId === '') {
                setSelectedCohortId(activeCohorts[0].id!);
            }
            setLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (from !== null && to !== null && to.diff(from, 'day') >= 0 && selectedCohortId !== '') {
            setLoading(true);
            getCalendarSessions(selectedCohortId, from.format('YYYY-MM-DD'), to.format('YYYY-MM-DD')).then(result => {
                setSessions(result ?? []);
                setLoading(false);
            });
        }
    }, [from, to, selectedCohortId]);

    const openDetail = (eventId: string) => {
        navigate(EDUCATION_SESSION_ATTENDANCE_DETAIL
            .replace(":cohortId", String(selectedCohortId))
            .replace(":eventId", encodeURIComponent(eventId)));
    }

    return (
        <div className={commonStyles.content} >
            <FormControl size="small" sx={{ minWidth: 200, mb: 2 }}>
                <InputLabel>Cohort</InputLabel>
                <Select
                    value={selectedCohortId}
                    label="Cohort"
                    onChange={(e) => setSelectedCohortId(e.target.value as number)}
                >
                    {cohorts.map(c => (
                        <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <BaseList
                storageKey="SESSION_ATTENDANCE"
                rows={sessions}
                columns={columns}
                loading={loading}
                localeText={{ noRowsLabel: "No sessions found" }}
                getRowId={(row) => row?.eventId ?? `${row?.day}_${row?.title}`}
                onRowClick={(e) => openDetail(e.row?.eventId)}
                from={from}
                to={to}
                setFrom={setFrom}
                setTo={setTo}
            />
        </div>
    );
}
